import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useCountry, Country } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<Country>
    useData={useCountry}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
